import { ICON_BASE_PATH } from "../../utils/config";

interface DrawerHeaderProps {
  handleClose: () => void;
  title?: string;
  subtitle: string;
  variant?: 'default' | 'grey'; // Add variant prop
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  handleClose,
  title,
  subtitle,
  variant = 'default', // Default to 'default'
}) => {
  // Determine close button class based on variant
  const closeButtonClass = `gx-drawer-close-button ${
    variant === 'grey' ? 'gx-drawer-close-button-grey' : ''
  }`.trim();

  return (
    <div className="gx-drawer-header">
      <div className="gx-drawer-title-h2">
        {title && subtitle === "" ? null : (
          <h2 className="gx-h2-26-l">
            {title}
            <span className="gx-h2-26-b">{subtitle}</span>
          </h2>
        )}
      </div>

      <button
        type="button"
        className={closeButtonClass}
        onClick={handleClose}
        aria-label="Close drawer"
      >
        <img
          className="gx-icon-primary"
          src={`${ICON_BASE_PATH}close.svg`}
          alt=""
        />
      </button>
    </div>
  );
};

export default DrawerHeader;